import * as React from 'react'
import {Suspense, useContext, useState, useEffect} from 'react'
import {api} from '../api/api'
import {AppContext} from '../app'
import ModalStatus from '../components/statusModal'
import '../css/contact.css'
import {AQUA_TEXT, AQUA_TEXT_FW500, tagger, setTitleFont} from '../util/util'
import {useTranslation} from 'react-i18next'

const UserAppAnimation = React.lazy(() => import('../lotties/user_app/userApp'))

const Contact = () => {

    const tAbout = useTranslation('about').t
    const tCommon = useTranslation('common').t
    const {t, i18n} = useTranslation('contact')

    useEffect(() => {
        setTitleFont(i18n.language)
    }, [])

    const {utmParameters} = useContext(AppContext)

    const statusModalData = {
        title: 'Message Sent',
        text: 'Your message has been recorded. We will reply as soon as possible.'
    }

    const [form, setForm] = useState({
        placement: 'RTB_form',
        name: '',
        email: '',
        phone: '',
        message: '',
        utm: utmParameters || {}
    })
    const [eName, setEName] = useState<string[]>([])
    const [eEmail, setEEmail] = useState<string[]>([])
    const [eMessage, setEMessage] = useState<string[]>([])

    const [statusModal, setStatusModal] = useState(false)

    const toggleStatusModal = () => setStatusModal(!statusModal)

    const updateErrors = (name, email, message) => {
        setEName(name)
        setEEmail(email)
        setEMessage(message)
    }

    const sendFormData = () => {
        updateErrors([], [], [])
        if (form.name && form.email && form.message) {
            api.postContactFormData(JSON.stringify(form))
                .then(() => {
                    setForm({
                        ...form,
                        name: '',
                        email: '',
                        phone: '',
                        message: ''
                    })
                    toggleStatusModal();
                    (window as any).dataLayer.push({ 'event': 'form-completed', 'location': 'Contact' })
                })
        } else {
            updateErrors(
                form.name ? [] : [tCommon('required field')],
                form.email ? [] : [tCommon('required field')],
                form.message ? [] : [tCommon('required field')]
            )
        }
    }

    return (
        <div className="common-pages-container contact">
            <ModalStatus data={statusModalData} show={statusModal} toggle={toggleStatusModal} />
            <div className="contact-left">
                <div className="title muli not-desktop not-mobile" >{tagger(t('Get in Touch'), AQUA_TEXT)}</div>
                <div className="get-in-t-l">
                    <div className="title muli not-tablet">{tagger(t('Get in Touch'), AQUA_TEXT)}</div>
                    <div className="text">{tagger(t('Lets grow your userbase'), AQUA_TEXT_FW500)}
                        <br className="not-desktop not-mobile" />
                        <br className="not-desktop not-mobile" />
                        <span className="get-in-tablet-span">{t('were looking forward')}</span>
                    </div>
                </div>
                <div className="lottie-user-app-container get-in-t-r">
                    <Suspense fallback="">
                        <UserAppAnimation />
                    </Suspense>
                </div>
            </div>
            <div className="contact-right">
                <div className="text mt-10 mb-35 not-mobile">{tagger(t('Fill in the form'), AQUA_TEXT_FW500)}</div>
                <div className="contact-input-container">
                    <input className={'contact-input small-text' + (eName.length > 0 ? ' error-input' : '')} type="input" name="name" placeholder="&nbsp;" value={form.name}
                        onChange={e => setForm({...form, name: e.currentTarget.value})} />
                    <span className="contact-input-label">{tAbout('Full name')}</span>
                </div>
                {eName && eName.map(err => <div className="error-small" key={err}>{err}</div>)}
                <div className="contact-input-container">
                    <input className={'contact-input small-text' + (eEmail.length > 0 ? ' error-input' : '')} type="email" name="email" placeholder="&nbsp;" value={form.email}
                        onChange={e => setForm({...form, email: e.currentTarget.value})} />
                    <span className="contact-input-label">{tAbout('Email address')}</span>
                </div>
                {eEmail && eEmail.map(err => <div className="error-small" key={err}>{err}</div>)}
                <div className="contact-input-container">
                    <input className="contact-input small-text" type="input" name="phone" placeholder="&nbsp;" value={form.phone}
                        onChange={e => setForm({...form, phone: e.currentTarget.value})} />
                    <span className="contact-input-label">{tAbout('Phone number')}</span>
                </div>
                <div className="contact-input-area-container">
                    <textarea className={'contact-input contact-textarea small-text' + (eMessage.length > 0 ? ' error-input' : '')}
                        name="contactMessage" placeholder="&nbsp;" value={form.message}
                        onChange={e => setForm({...form, message: e.currentTarget.value})} />
                    <span className="contact-input-label">{t('Message')}</span>
                </div>
                {eMessage && eMessage.map(err => <div className="error-small" key={err}>{err}</div>)}
                <button className="button-aqua large" onClick={sendFormData}>{tCommon('Send')}</button>
            </div>
        </div>
    )
}

export default Contact



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/pages/contact.tsx